(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }
  function norm(v){
    return String(v||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'').trim();
  }
  function euro(cents){
    var n=Math.max(0,Math.round(Number(cents||0)/100));
    try{return n.toLocaleString('es-ES')+' €';}catch(e){return String(n)+' €';}
  }
  function parseEuro(value){
    var s=String(value==null?'':value).trim().replace(/\s/g,'').replace(/€/g,'');
    if(!s) return 0;
    if(s.indexOf(',')>-1){s=s.replace(/\./g,'').replace(',','.');}
    else if((s.match(/\./g)||[]).length>1){s=s.replace(/\./g,'');}
    var n=parseFloat(s);
    return isNaN(n)?0:Math.round(n*100);
  }
  function financeOpeningRate(months){
    var rates={3:.03,6:.03,10:.03,12:.03,18:.04,24:.04,30:.06,36:.07};
    return Object.prototype.hasOwnProperty.call(rates,months)?rates[months]:.04;
  }
  function financeMonthly(principalCents,months){
    if(!principalCents||!months)return 0;
    return Math.round((principalCents*(1+financeOpeningRate(months)))/months);
  }

  function initFinance(root){
    var card=root.querySelector('[data-lbx-finance-card]');
    if(!card||card.dataset.lbxV23Finance==='1')return;
    card.dataset.lbxV23Finance='1';

    var priceNode=root.querySelector('[data-lbx-price]');
    var cash=card.querySelector('[data-lbx-finance-cash]');
    var monthly=card.querySelector('[data-lbx-finance-monthly]');
    var subline=card.querySelector('[data-lbx-finance-subline]');
    var entry=card.querySelector('[data-lbx-finance-entry]');
    var controls=card.querySelector('[data-lbx-finance-controls]');
    var toggle=card.querySelector('[data-lbx-finance-toggle]');
    var monthsButtons=Array.prototype.slice.call(card.querySelectorAll('[data-lbx-finance-month]'));
    var financeButton=card.querySelector('[data-lbx-finance-reserve]');
    var contact=card.querySelector('[data-lbx-finance-contact]');
    var selected=parseInt(card.getAttribute('data-lbx-finance-current-months'),10)||24;

    function priceCents(){
      var fromAttr=priceNode&&parseInt(priceNode.getAttribute('data-lbx-price-cents'),10);
      if(fromAttr&&fromAttr>0)return fromAttr;
      if(cash)return parseEuro(cash.textContent);
      return 0;
    }
    function entryCents(){
      var p=priceCents();
      var e=entry?parseEuro(entry.value):0;
      return Math.max(0,Math.min(p,e));
    }
    function paint(){
      var p=priceCents();
      var e=entryCents();
      var principal=Math.max(0,p-e);
      card.setAttribute('data-lbx-finance-current-months',String(selected));
      monthsButtons.forEach(function(btn){
        var on=parseInt(btn.getAttribute('data-lbx-finance-month'),10)===selected;
        btn.classList.toggle('is-active',on);
        btn.setAttribute('aria-pressed',on?'true':'false');
      });
      if(cash)cash.textContent=euro(p);
      if(monthly)monthly.textContent=euro(financeMonthly(principal,selected)).replace(' €',' €/mes');
      if(subline)subline.textContent='A '+selected+' meses con entrada de '+euro(e);
      if(entry&&document.activeElement!==entry)entry.value=String(Math.round(e/100));
      if(contact){
        var title=(root.querySelector('[data-lbx-product-title]')||{}).textContent||document.title.split('|')[0].trim();
        var msg='Hola, quiero información sobre la financiación de '+title+'. Entrada: '+euro(e)+'. Plazo: '+selected+' meses. Cuota estimada: '+euro(financeMonthly(principal,selected)).replace(' €',' €/mes')+'.';
        contact.href='https://wa.me/34690041276?text='+encodeURIComponent(msg);
      }
      card.dispatchEvent(new CustomEvent('lbx:v23-finance-change',{bubbles:true,detail:{priceCents:p,entryCents:e,months:selected,monthlyCents:financeMonthly(principal,selected)}}));
    }
    function setControlsOpen(open){
      if(controls)controls.hidden=!open;
      card.classList.toggle('is-open',!!open);
      if(toggle)toggle.setAttribute('aria-expanded',open?'true':'false');
      if(open)paint();
    }
    function openControls(){setControlsOpen(true);}
    function closeControls(){setControlsOpen(false);}
    function openRequest(){
      paint();
      var modal=root.querySelector('[data-lbx-wishlist-modal]');
      if(!modal){ if(contact)contact.click(); return; }
      var kicker=modal.querySelector('[data-lbx-wishlist-modal-kicker]');
      var title=modal.querySelector('[data-lbx-wishlist-modal-title]');
      var lead=modal.querySelector('[data-lbx-wishlist-modal-lead]');
      var label=modal.querySelector('[data-lbx-wishlist-note-label]');
      var note=modal.querySelector('[data-lbx-wishlist-note]');
      var submit=modal.querySelector('[data-lbx-wishlist-submit]');
      var p=priceCents(),e=entryCents(),principal=Math.max(0,p-e),m=financeMonthly(principal,selected);
      modal.classList.add('is-finance-mode');
      if(kicker)kicker.textContent='Financiación LaBosch';
      if(title)title.textContent='Solicitar financiación';
      if(lead)lead.textContent='Déjanos tus datos y te contactaremos para gestionar esta simulación contigo.';
      if(label)label.textContent='Simulación elegida';
      if(note){
        note.value='Entrada inicial: '+euro(e)+'. Plazo: '+selected+' meses. Cuota estimada: '+euro(m).replace(' €',' €/mes')+'. Importe a financiar: '+euro(principal)+'.';
        note.setAttribute('data-lbx-finance-note-lock','true');
      }
      if(submit)submit.textContent='Enviar solicitud de financiación';
      modal.hidden=false;
      modal.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow='hidden';
    }

    /* Financing must start collapsed. It only expands from the calculator control
       or from the explicit top-page finance CTA. */
    closeControls();

    monthsButtons.forEach(function(btn){
      btn.addEventListener('click',function(ev){
        ev.preventDefault(); ev.stopImmediatePropagation();
        var m=parseInt(btn.getAttribute('data-lbx-finance-month'),10);
        if(m){selected=m;paint();}
      },true);
    });
    if(entry){
      entry.addEventListener('input',paint,true);
      entry.addEventListener('change',paint,true);
      entry.addEventListener('blur',function(){entry.value=String(Math.round(entryCents()/100));paint();},true);
    }
    if(toggle){
      toggle.addEventListener('click',function(ev){
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var shouldOpen=!card.classList.contains('is-open');
        setControlsOpen(shouldOpen);
        if(shouldOpen&&entry)setTimeout(function(){entry.focus();},20);
      },true);
    }
    if(financeButton){
      /* Let the native LaBosch runtime open its finance request flow. V23 only
         guarantees the calculator state first, then falls back to WhatsApp if
         the runtime does not open a modal for any reason. */
      financeButton.addEventListener('click',function(){
        paint();
        setTimeout(function(){
          var modal=root.querySelector('[data-lbx-wishlist-modal]');
          var opened=modal && !modal.hidden && modal.getAttribute('aria-hidden')!=='true';
          if(!opened && contact && contact.href){ window.open(contact.href,'_blank','noopener'); }
        },180);
      });
    }
    root.querySelectorAll('[data-lbx-finance-jump]').forEach(function(jump){
      jump.addEventListener('click',function(ev){ev.preventDefault();ev.stopImmediatePropagation();card.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(openControls,220);},true);
    });

    if(priceNode && window.MutationObserver){
      new MutationObserver(function(){paint();}).observe(priceNode,{attributes:true,attributeFilter:['data-lbx-price-cents'],childList:true,subtree:true,characterData:true});
    }
    paint();
  }

  function safeParse(v){
    if(v==null)return null; var out=v;
    for(var i=0;i<4&&typeof out==='string';i++){
      var s=out.trim(); if(!s)return null;
      try{out=JSON.parse(s);}catch(e){break;}
    }
    if(out&&typeof out==='object'&&Object.prototype.hasOwnProperty.call(out,'value'))return safeParse(out.value);
    return out;
  }
  function normalizeGuide(raw){
    raw=safeParse(raw);var list=[];
    function add(size,min,max){min=parseFloat(min);max=parseFloat(max);if(size&&!isNaN(min)&&!isNaN(max)){if(min>max){var tmp=min;min=max;max=tmp;}list.push({size:String(size),min:min,max:max});}}
    if(Array.isArray(raw))raw.forEach(function(it){it=safeParse(it);if(!it||typeof it!=='object')return;add(it.talla||it.size||it.label||it.name,it.min||it.min_cm||it.cm_min||it.desde||it.from,it.max||it.max_cm||it.cm_max||it.hasta||it.to);});
    else if(raw&&typeof raw==='object')Object.keys(raw).forEach(function(k){var it=safeParse(raw[k]);if(!it||typeof it!=='object')return;add(it.talla||it.size||it.label||it.name||k,it.min||it.min_cm||it.cm_min||it.desde||it.from,it.max||it.max_cm||it.cm_max||it.hasta||it.to);});
    return list;
  }
  function fallback(size){
    var map={xxs:[135,145],xs:[141,150],s:[151,160],m:[161,170],l:[171,180],xl:[181,190],xxl:[191,201],'48':[157,167],'51':[165,175],'54':[170,180],'56':[175,185],'58':[182,193],'61':[190,203]};
    var r=map[norm(size)];return r?{size:String(size),min:r[0],max:r[1]}:null;
  }
  function readGuide(root){
    var candidates=[];
    root.querySelectorAll('[data-lbx-real-size-guide],[data-lbx-real-size-guide-pack],[data-lbx-real-size-guide-scan],[data-lbx-real-size-guide-raw],[data-lbx-real-size-guide-text]').forEach(function(node){
      var raw=node.tagName&&node.tagName.toLowerCase()==='template'?(node.innerHTML||node.textContent||''):(node.textContent||'');
      var parsed=safeParse(raw);if(parsed)candidates.push(parsed);
    });
    for(var i=0;i<candidates.length;i++){
      var direct=normalizeGuide(candidates[i]);if(direct.length)return direct;
      if(candidates[i]&&typeof candidates[i]==='object'){
        var keys=Object.keys(candidates[i]);
        for(var j=0;j<keys.length;j++){var nested=normalizeGuide(candidates[i][keys[j]]);if(nested.length)return nested;}
      }
    }
    return [];
  }
  function displaySize(value){return String(value||'').replace(/^\s*talla\s*/i,'').trim();}
  function initSizeGuide(root){
    if(window.matchMedia && window.matchMedia('(max-width:1024px)').matches) return;
    var modal=root.querySelector('[data-lbx-size-guide-modal]');
    if(!modal||modal.dataset.lbxV23Size==='1')return;
    modal.dataset.lbxV23Size='1';
    var table=modal.querySelector('[data-lbx-size-guide-table]');
    var result=modal.querySelector('[data-lbx-size-guide-result]');
    var input=modal.querySelector('[data-lbx-height-input]');
    var unit=modal.querySelector('[data-lbx-unit-select]');
    var selectBtn=modal.querySelector('[data-lbx-size-guide-select-size]');
    var recommended=null;

    function sizes(){
      var out=[];
      root.querySelectorAll('.lbx-size-button[data-lbx-option-value]').forEach(function(btn){var s=btn.getAttribute('data-lbx-option-value');if(s&&out.indexOf(s)<0)out.push(s);});
      return out;
    }
    function data(){
      var ss=sizes(),real=readGuide(root),by={};real.forEach(function(x){by[norm(x.size)]=x;});
      var out=ss.map(function(s){return by[norm(s)]||fallback(s);}).filter(Boolean);
      if(!out.length)out=real;
      return out.sort(function(a,b){return a.min-b.min;});
    }
    function hcm(){var n=parseFloat(input&&input.value);if(isNaN(n))return null;return unit&&unit.value==='in'?n*2.54:n;}
    function choose(h,d){
      if(h==null||!d.length)return null;
      var exact=d.filter(function(x){return h>=x.min&&h<=x.max;});
      var pool=exact.length?exact:d;
      return pool.slice().sort(function(a,b){var ca=(a.min+a.max)/2,cb=(b.min+b.max)/2;return Math.abs(h-ca)-Math.abs(h-cb);})[0];
    }
    function render(){
      var d=data(),h=hcm();recommended=choose(h,d);
      if(table){
        table.innerHTML=d.map(function(x){var rec=recommended&&norm(recommended.size)===norm(x.size);return '<div class="lbx-v23-size-card'+(rec?' is-recommended':'')+'" data-lbx-v23-size="'+String(x.size).replace(/"/g,'&quot;')+'"><span class="lbx-v23-size-card__caption">Talla</span><strong class="lbx-v23-size-card__size">'+x.size+'</strong><span class="lbx-v23-size-card__range">'+Math.round(x.min)+'–'+Math.round(x.max)+' cm</span></div>';}).join('');
      }
      if(result){
        if(!d.length)result.innerHTML='<span class="lbx-size-guide-result-label">Guía de talla</span><span class="lbx-size-guide-result-size">—</span><span>No hay medidas configuradas para este modelo.</span>';
        else if(h==null)result.innerHTML='<span class="lbx-size-guide-result-label">Talla recomendada</span><span class="lbx-size-guide-result-size">—</span><span>Introduce tu altura para ver la recomendación.</span>';
        else result.innerHTML='<span class="lbx-size-guide-result-label">Talla recomendada</span><span class="lbx-size-guide-result-size">'+recommended.size+'</span><span>Para <strong>'+Math.round(h)+' cm</strong>. Rango orientativo: <strong>'+Math.round(recommended.min)+'–'+Math.round(recommended.max)+' cm</strong>.</span>';
      }
      if(selectBtn){
        selectBtn.disabled=!recommended;
        selectBtn.textContent=recommended?'Usar talla '+displaySize(recommended.size):'Seleccionar talla recomendada';
      }
    }
    function after(){setTimeout(render,0);setTimeout(render,60);}
    root.querySelectorAll('[data-lbx-size-guide-open],[data-mg2-size-guide]').forEach(function(btn){btn.addEventListener('click',after);});
    modal.querySelectorAll('[data-lbx-height-decrease],[data-lbx-height-increase]').forEach(function(btn){btn.addEventListener('click',after);});
    if(input){input.addEventListener('input',render);input.addEventListener('change',render);}
    if(unit)unit.addEventListener('change',after);
    if(selectBtn){
      selectBtn.addEventListener('click',function(){
        if(!recommended)return;
        var target=Array.prototype.find.call(root.querySelectorAll('.lbx-size-button[data-lbx-option-value]'),function(btn){return norm(btn.getAttribute('data-lbx-option-value'))===norm(recommended.size);});
        if(target)target.click();
      });
    }
    render();
  }

  ready(function(){
    document.querySelectorAll('.lbx-product-pro,[id^="lbx-product-"]').forEach(function(root){initFinance(root);initSizeGuide(root);});
  });
})();
